import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as ContractModels from '../../models/contract/contract';
import { EnvironmentService } from '../environment.service';
import * as Models from "../../models/commonModels";

@Injectable({
  providedIn: 'root'
})
export class ContractService {


  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: ContractModels.ContractSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };
    Search.RequestSignature = Math.random();

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractPreviewModel>>(`${this.environmentService.getApiURL()}/contract/list`, Search, options);
  }

  public set(Contract: Models.Request<ContractModels.ContractModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/set`, Contract, options);
  }

  public setStatus(Contract: Models.Request<ContractModels.ContractModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/set-status`, Contract, options);
  }

  public active(Contract: Models.Request<ContractModels.ContractModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/set/active`, Contract, options);
  }

  public get(Contract: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/get`, Contract, options);
  }

  public getActiveForCustomer(Contract: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/get-active-for-customer`, Contract, options);
  }

  public create(Contract: Models.Request<ContractModels.ContractModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/create`, Contract, options);
  }

  public publishSend(Contract: Models.Request<ContractModels.ContractPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/publish`, Contract, options);
  }

  public sendAgain(Contract: Models.Request<ContractModels.ContractPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/send-again`, Contract, options);
  }

  public approveForClient(Contract: Models.Request<ContractModels.ContractPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/approve-for-client`, Contract, options);
  }

  public download(Contract: Models.Request<ContractModels.ContractPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };
    return this.httpClient.post<Blob>(
      `${this.environmentService.getApiURL()}/contract/download`,
      Contract,
      options
    );
  }

  public getDiscount(Contract: Models.Request<ContractModels.ContractDiscountSearch>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractDiscountPreviewModel>>(`${this.environmentService.getApiURL()}/contract/get/discount`, Contract, options);
  }

  public setDiscount(Discount: Models.Request<ContractModels.SetContractDiscountPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractDiscountPreviewModel>>(`${this.environmentService.getApiURL()}/contract/set/discount`, Discount, options);
  }

  public getGarages(Contract: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractGaragePreviewModel>>(`${this.environmentService.getApiURL()}/contract/garages`, Contract, options);
  }

  public getContractGarageServicePriceList(Search: ContractModels.ContractGarageServicePriceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractGarageServicePriceModel>>(`${this.environmentService.getApiURL()}/contract/garage/service/price/list`, Search, options);
  }

  public setContractGarageServicePriceList(Set: Models.Request<ContractModels.SetContractGarageServicePriceModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractGarageServicePriceModel>>(`${this.environmentService.getApiURL()}/contract/garage/service/price/list/set`, Set, options);
  }

  public clearContractGarageServicePriceList(Clear: ContractModels.ContractGarageServicePriceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractGarageServicePriceModel>>(`${this.environmentService.getApiURL()}/contract/garage/service/price/list/clear`, Clear, options);
  }

  public setExtraParameter(Parameter: Models.Request<ContractModels.ContractExtraParameterModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractExtraParameterModel>>(`${this.environmentService.getApiURL()}/contract/set/extra-paraemters`, Parameter, options);
  }

  public getExtraParametersList(Contract: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractExtraParameterModel>>(`${this.environmentService.getApiURL()}/contract/get/extra-paraemters`, Contract, options);
  }

  public removeExtraParameters(Parameter: Models.Request<ContractModels.ContractExtraParameterModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractExtraParameterModel>>(`${this.environmentService.getApiURL()}/contract/remove/extra-paraemters`, Parameter, options);
  }

  public getPreviousContract(Contract: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/previous`, Contract, options);
  }

  public getContractDiscountExcelReport(search: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/contract/discount/report-excel`, search, options);
  }

  public importContractDiscount(Data: any) {
    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/contract/discount/import`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getContractPriceListExcelReport(search: ContractModels.ContractGarageServicePriceSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders, responseType: "blob" as "json" };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/contract/garage/service/price/report-excel`, search, options);
  }

  public importContracPriceList(Data: any) {
    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' };

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/contract/garage/service/price/import`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getSubCustomerPriceItems(Search: ContractModels.ContractSubCustomerPriceSearch) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractSubCustomerPricePreviewModel>>(`${this.environmentService.getApiURL()}/contract/subcustomer/price/items`, Search, options);
  }

  public setSubCustomerPriceItems(Set: Models.Request<ContractModels.ContractSubCustomerPricePreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractSubCustomerPricePreviewModel>>(`${this.environmentService.getApiURL()}/contract/subcustomer/price/set`, Set, options);
  }

  public removeSubCustomerPriceItems(Remove: Models.Request<ContractModels.ContractSubCustomerPricePreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractSubCustomerPricePreviewModel>>(`${this.environmentService.getApiURL()}/contract/subcustomer/price/remove`, Remove, options);
  }

  public getSubCustomerExtraParametersItems(Search: ContractModels.ContractSubCustomerExtraParametersSearch) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractSubCustomerExtraParametersPreviewModel>>(`${this.environmentService.getApiURL()}/contract/subcustomer/extra-paraemters/items`, Search, options);
  }

  public setSubCustomerExtraParametersItems(Set: Models.Request<ContractModels.ContractSubCustomerExtraParametersPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractSubCustomerExtraParametersPreviewModel>>(`${this.environmentService.getApiURL()}/contract/subcustomer/extra-paraemters/set`, Set, options);
  }

  public removeSubCustomerExtraParametersItems(Remove: Models.Request<ContractModels.ContractSubCustomerExtraParametersPreviewModel>) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<ContractModels.ContractSubCustomerExtraParametersPreviewModel>>(`${this.environmentService.getApiURL()}/contract/subcustomer/extra-paraemters/remove`, Remove, options);
  }

  public setDocumentFile(Contract: Models.Request<ContractModels.ContractModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("ContractId", Contract.Item.ContractId.toString());
    formData.append("RequestSignature", Contract.RequestSignature.toString());

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/set-document`, formData);
  }

  public getDocumentFile(Contract: Models.Request<ContractModels.ContractModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/contract/get-document`, Contract, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public getCarCurrent(Car: Models.RequestModel) {
    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("Cache-Control", "no-cache");

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<ContractModels.ContractModel>>(`${this.environmentService.getApiURL()}/contract/get-car-current`, Car, options);
  }
}
